/* globals $, globalScene, allTweens, controller */
import { TimelineMax, Strong } from 'gsap';
import 'gsap/ScrollToPlugin';

import ScrollMagic from 'helpers/importers/ScrollMagic';
import calculateOffset from 'helpers/calculateOffset';

export default function studio () {

  let tween = new TimelineMax()
    .from($('#studio > .wrapper h2'), 1, {
      xPercent: -120,
      opacity: 0,
      ease: Strong.easeOut,
    })
    .from($('#studio > .wrapper > div > div'), 1, {
      xPercent: 120,
      opacity: 0,
      ease: Strong.easeOut,
    }, '=-1')
    .from($('#slider > .wrapper'), 1, {
      opacity: 0,
      onReverseStart: () => {
        $(window).trigger('slider-stop');
      },
      onComplete: () => {
        $(window).trigger('slider-start');
      },
    }, '=-0.3');

  allTweens.push(tween);

  let scene = new ScrollMagic.Scene({
    triggerElement: '#studio',
    offset: calculateOffset(5),
    duration: '2%',
    triggerHook: 'onEnter',
  });
  //.addIndicators({name: "studio"});

  let sceneStart = new ScrollMagic.Scene({
    triggerElement: '#studio',
    offset: calculateOffset(-50),
    duration: 0,
    triggerHook: 'onCenter',
  })
  //.addIndicators({name: "studio_anim"})
  .setTween(tween);

  scene.enabled(false);
  sceneStart.enabled(false);

  sceneStart.addTo(controller);
  scene.addTo(controller);

  globalScene.push(scene);
  globalScene.push(sceneStart);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/studioScene.js